/* eslint-disable no-unused-vars */
import React, { ReactNode } from 'react';

// Redux
import { useSelector } from 'react-redux';

// Clsx
import clsx from 'clsx';

// Types
import { ApplicationState } from 'store';

// Constants
import PATHS from 'constants/paths';

// Components
import ErrorBoundary from '../ErrorBoundary';

import useStyles from './styles';

interface StateProps {
  children: ReactNode;
}

interface DispatchProps {}

interface OwnProps {
  className?: string;
  noActive?: boolean;
}

type Props = StateProps & DispatchProps & OwnProps;

const MainContent: React.FunctionComponent<Props> = ({
  children,
  className,
  noActive,
}) => {
  const classes = useStyles();

  const drawerOpen = useSelector(
    (state: ApplicationState) => state.drawer.open,
  );

  const { pathname: routeActive } = window.location;

  const currentPath = PATHS.find((path) => path === routeActive);

  return (
    <main
      className={clsx(classes.content, className, {
        [classes.small]: drawerOpen && !noActive,
        [classes.large]: !drawerOpen && routeActive !== currentPath,
      })}>
      <div className={classes.toolbar} />
      <ErrorBoundary>{children}</ErrorBoundary>
    </main>
  );
};

export default MainContent;
